import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetMatchQuery, useGetMatchRunsQuery } from '../api';
import { leagueActions } from '../slice';

export const useMatchPolling = (leagueId: string, matchId: string) => {
  const dispatch = useDispatch();

  const {
    data: matchData,
    error: matchError,
    isLoading: matchLoading,
    isFetching: matchFetching,
    refetch: refetchMatch,
  } = useGetMatchQuery(
    { league_id: leagueId, match_id: matchId },
    { skip: !leagueId || !matchId },
  );

  const {
    data: runsData,
    error: runsError,
    isLoading: runsLoading,
    isFetching: runsFetching,
    refetch: refetchRuns,
  } = useGetMatchRunsQuery(
    { league_id: leagueId, match_id: matchId },
    { skip: !matchData },
  );

  useEffect(() => {
    if (matchData) dispatch(leagueActions.setLeagueMatch(matchData));
  }, [matchData, dispatch]);

  useEffect(() => {
    if (!runsFetching && runsData) {
      dispatch(leagueActions.updateRuns(runsData));
    }
  }, [runsFetching, runsData, dispatch]);

  return {
    matchData,
    matchError,
    matchLoading,
    runsData,
    runsError,
    runsLoading,
    loading: matchLoading || runsLoading,
    error: matchError || runsError,
    refetchMatch,
    refetchRuns,
  };
};
